import { lineHeight as legacyLineHeight } from '@offerzen/pinata-shame'

export { borderRadius, spacing, fontSize, fontWeight, fontFamily, breakpoint, zIndex } from '@offerzen/pinata-shame'

export const lineHeight = {
  ...legacyLineHeight,
  large: 1.4,
}
